



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DateInput from "@/components/common/DateInput.vue";
import moment from "moment";

@Component({
  components: {
    DateInput
  },
})
export default class EventDate extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop({default: []})
  private rules!: object[];

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop()
  private color?: string;

  @Prop({default: 'primary'})
  private headerColor?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Prop({default: 'primary'})
  private pickerColor?: string;

  @Prop({default: true})
  private rounded?: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  @Watch('inputData')
  watchInputData() {
    this.$emit('input', this.inputData)
  }

  private inputData: string = '';
  private minDate:string = '';
  private maxDate:string = '';

  mounted() {
    this.minDate = moment().format('YYYY-MM-DD');
    this.maxDate = moment().add(3, 'months').format('YYYY-MM-DD');
  }

}
